// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Box } from '@mui/material';

// project imports
import LogoSection from '../LogoSection';
import SearchSection from './SearchSection';
import NewSearchIcon from './SearchSection/NewSearchIcon';
import NewTwoSearchIcon from './SearchSection/NewTwoSearchIcon';
import MobileSection from './MobileSection';
import ProfileSection from './ProfileSection';
import LocalizationSection from './LocalizationSection';
import MegaMenuSection from './MegaMenuSection';
import NotificationSection from './NotificationSection';
import { useDispatch, useSelector } from 'store';
import { openDrawer } from 'store/slices/menu';
import CustomBottomNavigation from './MobileSection/CustomBottomNavigation';

// assets
import { IconMenu2 } from '@tabler/icons';
import useAuth from 'hooks/useAuth';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = () => {
    const { defaultRole, isLoggedIn, user } = useAuth();
    const theme = useTheme();

    const dispatch = useDispatch();
    const { drawerOpen } = useSelector((state) => state.menu);

    return (
        <>
            {/* logo & toggler button */}
            {/* <Box
                sx={{
                    width: 228,
                    display: 'flex',
                    [theme.breakpoints.down('md')]: {
                        width: 'auto'
                    }
                }}
            >
                <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
                    <LogoSection />
                </Box>
                <Avatar
                    variant="rounded"
                    sx={{
                        ...theme.typography.commonAvatar,
                        ...theme.typography.mediumAvatar,
                        overflow: 'hidden',
                        transition: 'all .2s ease-in-out',
                        background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.secondary.light,
                        color: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.secondary.dark,
                        '&:hover': {
                            background: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.secondary.dark,
                            color: theme.palette.mode === 'dark' ? theme.palette.secondary.light : theme.palette.secondary.light
                        }
                    }}
                    onClick={() => dispatch(openDrawer(!drawerOpen))}
                    color="inherit"
                >
                    <IconMenu2 stroke={1.5} size="20px" />
                </Avatar>
            </Box> */}

            {/* Logo */}
            {/* <Box>
                <span style={{ fontWeight: 800, fontSize: 24 }}>PBX App</span>
            </Box> */}
            <Box sx={{ display: { sm: 'block' } }}>
                <Box sx={{ display: 'flex', pl: 0.5, pt: 0.5, mx: 'auto' }}>
                    <LogoSection />
                </Box>
            </Box>

            {/* New Header Search */}
            {/* <Box sx={{ flexGrow: 1 }} />
            <NewSearchIcon /> */}

            {/* New two header search */}
            <Box sx={{ flexGrow: 1 }} />
            <Box sx={{ flexGrow: 1 }} />
            {/* <NewTwoSearchIcon /> */}

            {/* header search */}
            {/* <SearchSection />
            <Box sx={{ flexGrow: 1 }} />
            <Box sx={{ flexGrow: 1 }} /> */}

            {/* mega-menu */}
            {/* <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                <MegaMenuSection />
            </Box> */}

            {/* live customization & localization */}
            {/* <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                <LocalizationSection />
            </Box> */}

            {/* notification & profile */}
            {/* <NotificationSection /> */}
            <ProfileSection />

            {/* mobile header */}
            {defaultRole !== 'securitygaurd' &&
            defaultRole !== 'organization' &&
            defaultRole !== 'accountant' &&
            defaultRole !== 'conductor' ? (
                <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
                    {/* <MobileSection /> */}
                    <CustomBottomNavigation />
                </Box>
            ) : null}
        </>
    );
};

export default Header;
